import { observer } from 'mobx-react-lite';
import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import { CircularProgress } from '@mui/material';
import { CSVLink } from 'react-csv';
import { withStyles } from '@mui/styles';
import DownloadImg from 'img/download.svg';

const styles = () => ({
    wrapper: {
        marginLeft: 'auto',
        width: 130
    },
    exportButton: {
        minWidth: 145,
        fontWeight: 700,
        '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.26)',
            opacity: 1
        }
    }
});


const DownloadCsv = observer(({ classes, request, enabled, onExport, filename, disabled }) => {
    const [transactionData, setTransactionData] = useState([]);
    const [loading, setLoading] = useState(false);

    const csvLink = useRef();

    const exportCompletions = () => {
        setLoading(true);
        request()
            .then((data) => {
                let resultData;
                if (typeof data === 'string') {
                    resultData = data;
                } else {
                    resultData = data.data;
                }
                if (onExport) {
                    onExport(resultData);
                }
                setTransactionData(resultData);
                csvLink.current.link.click();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className={classes.wrapper}>
            {
                enabled && (
                    <Button
                        disabled={loading || disabled}
                        color="primary"
                        className={classes.exportButton}
                        onClick={exportCompletions}
                    >
                        {
                            !loading ? (
                                <>
                                    {!disabled && <img className="u-mrg--rx1" src={DownloadImg} alt="|" />}
                                    <span>Download CSV</span>
                                </>
                            ) : (
                                <CircularProgress size={20} color="primary" />
                            )
                        }
                    </Button>
                )
            }
            <CSVLink
                data={transactionData}
                filename={filename}
                className="hidden"
                ref={csvLink}
                target="_blank"
            />
        </div>
    );
});

export default withStyles(styles)(DownloadCsv);
